import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import Modal from '../../../../../../components/modal';
import EditShiftsForm from '../../../../forms/editShifts';
import { TIMESHEET_ACTIONS, TIMESHEET_STATUS_LOCKED, TIMESHEET_STATUS } from '../../../../../../text/enumerations';
import { getTimesheetShifts } from '../../../../../../reducers/timekeeping';

class TimesheetActionsDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: { open: false },
            isConfirmed: false
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.renderModal = this.renderModal.bind(this);
        this.getDefaultComponent = this.getDefaultComponent.bind(this);
        this.determineAction = this.determineAction.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.isTimesheetConfirmed = this.isTimesheetConfirmed.bind(this);
    }

    componentDidMount() {
        this.setState({ ...this.state, isConfirmed: this.isTimesheetConfirmed(this.props) });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ ...this.state, isConfirmed: this.isTimesheetConfirmed(nextProps) });
    }

    onOpen() {
        const { timesheet, getTimesheetShifts } = this.props;
        this.setState({ ...this.state, modal: { open: true } }, () => getTimesheetShifts(timesheet.id));
    }

    onClose() {
        this.setState({ ...this.state, modal: { open: false } });
    }

    isTimesheetConfirmed(props) {
        const { job, timesheet, shifts } = props;
        if (!timesheet) return false;

        const timeValue = shift =>
            moment
                .tz(shift.updated_at, job.work_timezone)
                .toDate()
                .getTime();

        const ordered = shifts.sort((a, b) => timeValue(b) - timeValue(a));
        const confirmedTime = moment.tz(timesheet.worker_confirmed_at, job.work_timezone);
        if (ordered.length === 0) {
            return timesheet.worker_confirmed_at !== undefined && timesheet.worker_confirmed_at !== null;
        }

        const latestShift = moment.tz(ordered[0].updated_at, job.work_timezone);
        let isConfirmed = timesheet.worker_confirmed_at && latestShift < confirmedTime;

        return isConfirmed;
    }

    getTitle() {
        const action = this.determineAction();
        switch (action) {
            case TIMESHEET_ACTIONS.EDIT:
                return <FormattedMessage {...messages.updateTimesheet} />;

            case TIMESHEET_ACTIONS.REVIEW:
                return <FormattedMessage {...messages.reviewTimesheet} />;

            case TIMESHEET_ACTIONS.CONFIRM:
                return <FormattedMessage {...messages.submitTimesheet} />;

            case TIMESHEET_ACTIONS.VIEW:
            default:
                return <FormattedMessage {...messages.timesheetDetails} />;
        }
    }

    determineAction() {
        const { timesheet } = this.props;

        if (timesheet && TIMESHEET_STATUS_LOCKED.includes(timesheet.status)) {
            return TIMESHEET_ACTIONS.VIEW;
        }

        if (timesheet.status === TIMESHEET_STATUS.NOTAPPROVED) {
            return TIMESHEET_ACTIONS.EDIT;
        }

        return TIMESHEET_ACTIONS.CONFIRM;
    }

    renderModal() {
        const { modal } = this.state;
        const { job, timesheet, shifts, reloadData } = this.props;

        return (
            <Modal open={modal.open} onClose={this.onClose} size="col-sm-8 col-sm-offset-2 col-xs-12">
                <div>
                    <div className="row">
                        <div className="col-xs-12">
                            <h4>{this.getTitle()}</h4>
                        </div>
                    </div>
                    <EditShiftsForm
                        form={`edit-shifts-form-${timesheet.id}`}
                        action={this.determineAction()}
                        job={job}
                        timesheet={timesheet}
                        shifts={shifts}
                        reloadData={reloadData}
                        cancel={this.onClose}
                    />
                </div>
            </Modal>
        );
    }

    getDefaultComponent(onOpen) {
        const { isConfirmed } = this.state;
        const { timesheet } = this.props;

        if (timesheet) {
            if (TIMESHEET_STATUS.NOTAPPROVED === timesheet.status) {
                return (
                    <React.Fragment>
                        <span className="timesheet-confirmed">
                            {timesheet.approver_notes ? timesheet.approver_notes : <FormattedMessage {...messages.timesheetNotApproved} />}
                        </span>
                        <div>
                            <div className="action-button" onClick={onOpen}>
                                <i className="material-icons">done_all</i>
                                <FormattedMessage {...messages.updateAndSubmitTimesheet} />
                            </div>
                        </div>
                    </React.Fragment>
                );
            }

            if (TIMESHEET_STATUS_LOCKED.includes(timesheet.status)) {
                return (
                    <span className="timesheet-confirmed">
                        <FormattedMessage {...messages.timesheetSubmitted} />
                    </span>
                );
            }
        }

        if (isConfirmed) {
            return (
                <span className="timesheet-confirmed">
                    <FormattedMessage {...messages.timesheetConfirmed} />
                </span>
            );
        }

        return (
            <div className="action-button" onClick={onOpen}>
                <i className="material-icons">done_all</i>
                <FormattedMessage {...messages.submitTimesheet} />
            </div>
        );
    }

    render() {
        const { shifts, timesheet, job } = this.props;
        if (!shifts || !timesheet || !job) return null;

        const component = this.props.component || this.getDefaultComponent;

        return (
            <React.Fragment>
                {component(this.onOpen)}
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

TimesheetActionsDialog.defaultProps = {
    job: undefined,
    timesheet: undefined,
    component: undefined,
    reloadData: () => null
};
TimesheetActionsDialog.propTypes = {
    job: PropTypes.object.isRequired,
    timesheet: PropTypes.object,
    component: PropTypes.func,
    reloadData: PropTypes.func
};

const mapStateToProps = state => {
    return {
        role: state.identity.role
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getTimesheetShifts
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetActionsDialog);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/dialogs/timesheetActions/tenants/contractor/index.jsx